import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 0.25C12.2855 0.25 12.5462 0.412074 12.6725 0.668076L15.7308 6.8649L22.5694 7.85861C22.852 7.89966 23.0867 8.09754 23.1749 8.36905C23.2631 8.64056 23.1895 8.93861 22.9851 9.13788L18.0366 13.9614L19.2048 20.7724C19.2531 21.0538 19.1374 21.3381 18.9065 21.5059C18.6755 21.6738 18.3693 21.6959 18.1166 21.563L12 18.3473L5.88334 21.563C5.63065 21.6959 5.32446 21.6738 5.0935 21.5059C4.86254 21.3381 4.74687 21.0538 4.79513 20.7724L5.9633 13.9614L1.01484 9.13788C0.810414 8.93861 0.736841 8.64056 0.82506 8.36905C0.913278 8.09754 1.14799 7.89966 1.4305 7.85861L8.26911 6.8649L11.3274 0.668076C11.4538 0.412074 11.7145 0.25 12 0.25ZM12 2.69466L9.43971 7.88233C9.33046 8.10369 9.11929 8.25712 8.875 8.29261L3.15007 9.12449L7.29267 13.1625C7.46944 13.3348 7.5501 13.5831 7.50837 13.8264L6.53043 19.5282L11.651 16.8362C11.8695 16.7213 12.1305 16.7213 12.349 16.8362L17.4695 19.5282L16.4916 13.8264C16.4498 13.5831 16.5305 13.3348 16.7073 13.1625L20.8499 9.12449L15.1249 8.29261C14.8807 8.25712 14.6695 8.10369 14.5602 7.88233L12 2.69466Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgStar;
